import _toConsumableArray from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { GEOPOSITION_CHANNELS, NONPOSITION_SCALE_CHANNELS, SCALE_CHANNELS, supportLegend, X, Y } from '../channel';
import { getTypedFieldDef, hasConditionalFieldDef, isFieldDef } from '../channeldef';
import * as vlEncoding from '../encoding';
import { normalizeEncoding } from '../encoding';
import { GEOSHAPE, isMarkDef } from '../mark';
import { stack } from '../stack';
import { duplicate } from '../util';
import { assembleAxisSignals } from './axis/assemble';
import { parseUnitAxes } from './axis/parse';
import { parseData as _parseData } from './data/parse';
import { assembleLayoutSignals as _assembleLayoutSignals } from './layoutsize/assemble';
import { parseUnitLayoutSize } from './layoutsize/parse';
import { normalizeMarkDef } from './mark/init';
import { parseMarkGroups } from './mark/mark';
import { isLayerModel, ModelWithField } from './model';
import { replaceRepeaterInEncoding } from './repeater';
import { assembleTopLevelSignals, assembleUnitSelectionData, assembleUnitSelectionMarks, assembleUnitSelectionSignals } from './selection/assemble';
import { parseUnitSelection } from './selection/parse';
/**
 * Internal model of Vega-Lite specification for the compiler.
 */

export var UnitModel =
/*#__PURE__*/
function (_ModelWithField) {
  _inherits(UnitModel, _ModelWithField);

  function UnitModel(spec, parent, parentGivenName) {
    var _this;

    var parentGivenSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var repeater = arguments.length > 4 ? arguments[4] : undefined;
    var config = arguments.length > 5 ? arguments[5] : undefined;
    var fit = arguments.length > 6 ? arguments[6] : undefined;

    _classCallCheck(this, UnitModel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UnitModel).call(this, spec, 'unit', parent, parentGivenName, config, repeater, undefined, spec.view));
    _this.fit = fit;
    _this.specifiedScales = {};
    _this.specifiedAxes = {};
    _this.specifiedLegends = {};
    _this.specifiedProjection = {};
    _this.selection = {};
    _this.children = [];

    _this.initSize(Object.assign({}, parentGivenSize, spec.width ? {
      width: spec.width
    } : {}, spec.height ? {
      height: spec.height
    } : {}));

    var mark = isMarkDef(spec.mark) ? spec.mark.type : spec.mark;
    var encoding = _this.encoding = normalizeEncoding(replaceRepeaterInEncoding(spec.encoding || {}, repeater), mark);
    _this.markDef = normalizeMarkDef(spec.mark, encoding, config); // calculate stack properties

    _this.stack = stack(mark, encoding, _this.config.stack);
    _this.specifiedScales = _this.initScales(mark, encoding);
    _this.specifiedAxes = _this.initAxes(encoding);
    _this.specifiedLegends = _this.initLegend(encoding);
    _this.specifiedProjection = spec.projection; // Selections will be initialized upon parse.

    _this.selection = spec.selection;
    return _this;
  }

  _createClass(UnitModel, [{
    key: "scaleDomain",

    /**
     * Return specified Vega-lite scale domain for a particular channel
     * @param channel
     */
    value: function scaleDomain(channel) {
      var scale = this.specifiedScales[channel];
      return scale ? scale.domain : undefined;
    }
  }, {
    key: "axis",
    value: function axis(channel) {
      return this.specifiedAxes[channel];
    }
  }, {
    key: "legend",
    value: function legend(channel) {
      return this.specifiedLegends[channel];
    }
  }, {
    key: "initScales",
    value: function initScales(mark, encoding) {
      return SCALE_CHANNELS.reduce(function (scales, channel) {
        var fieldDef;
        var specifiedScale;
        var channelDef = encoding[channel];

        if (isFieldDef(channelDef)) {
          fieldDef = channelDef;
          specifiedScale = channelDef.scale;
        } else if (hasConditionalFieldDef(channelDef)) {
          fieldDef = channelDef.condition;
          specifiedScale = channelDef.condition['scale'];
        }

        if (fieldDef) {
          scales[channel] = specifiedScale || {};
        }

        return scales;
      }, {});
    }
  }, {
    key: "initAxes",
    value: function initAxes(encoding) {
      return [X, Y].reduce(function (_axis, channel) {
        // Position Axis
        // TODO: handle ConditionFieldDef
        var channelDef = encoding[channel];

        if (isFieldDef(channelDef) || channel === X && isFieldDef(encoding.x2) || channel === Y && isFieldDef(encoding.y2)) {
          var axisSpec = isFieldDef(channelDef) ? channelDef.axis : null;

          if (axisSpec !== null) {
            _axis[channel] = Object.assign({}, axisSpec);
          }
        }

        return _axis;
      }, {});
    }
  }, {
    key: "initLegend",
    value: function initLegend(encoding) {
      return NONPOSITION_SCALE_CHANNELS.reduce(function (_legend, channel) {
        var channelDef = encoding[channel];

        if (channelDef) {
          var legend = isFieldDef(channelDef) ? channelDef.legend : hasConditionalFieldDef(channelDef) ? channelDef.condition['legend'] : null;

          if (legend !== null && legend !== false && supportLegend(channel)) {
            _legend[channel] = Object.assign({}, legend);
          }
        }

        return _legend;
      }, {});
    }
  }, {
    key: "parseData",
    value: function parseData() {
      this.component.data = _parseData(this);
    }
  }, {
    key: "parseLayoutSize",
    value: function parseLayoutSize() {
      parseUnitLayoutSize(this);
    }
  }, {
    key: "parseSelections",
    value: function parseSelections() {
      this.component.selection = parseUnitSelection(this, this.selection);
    }
  }, {
    key: "parseMarkGroup",
    value: function parseMarkGroup() {
      this.component.mark = parseMarkGroups(this);
    }
  }, {
    key: "parseAxesAndHeaders",
    value: function parseAxesAndHeaders() {
      this.component.axes = parseUnitAxes(this);
    }
  }, {
    key: "assembleSelectionTopLevelSignals",
    value: function assembleSelectionTopLevelSignals(signals) {
      return assembleTopLevelSignals(this, signals);
    }
  }, {
    key: "assembleSignals",
    value: function assembleSignals() {
      return [].concat(_toConsumableArray(assembleAxisSignals(this)), _toConsumableArray(assembleUnitSelectionSignals(this, [])));
    }
  }, {
    key: "assembleSelectionData",
    value: function assembleSelectionData(data) {
      return assembleUnitSelectionData(this, data);
    }
  }, {
    key: "assembleLayout",
    value: function assembleLayout() {
      return null;
    }
  }, {
    key: "assembleLayoutSignals",
    value: function assembleLayoutSignals() {
      return _assembleLayoutSignals(this);
    }
  }, {
    key: "assembleMarks",
    value: function assembleMarks() {
      var marks = this.component.mark || []; // If this unit is part of a layer, selections should augment
      // all in concert rather than each unit individually. This
      // ensures correct interleaving of clipping and brushed marks.

      if (!this.parent || !isLayerModel(this.parent)) {
        marks = assembleUnitSelectionMarks(this, marks);
      }

      return marks.map(this.correctDataNames);
    }
  }, {
    key: "getMapping",
    value: function getMapping() {
      return this.encoding;
    }
  }, {
    key: "toSpec",
    value: function toSpec(excludeConfig, excludeData) {
      var encoding = duplicate(this.encoding);
      var spec;
      spec = {
        mark: this.markDef,
        encoding: encoding
      };

      if (!excludeConfig) {
        spec.config = duplicate(this.config);
      }

      if (!excludeData) {
        spec.data = duplicate(this.data);
      } // remove defaults


      return spec;
    }
  }, {
    key: "channelHasField",
    value: function channelHasField(channel) {
      return vlEncoding.channelHasField(this.encoding, channel);
    }
  }, {
    key: "fieldDef",
    value: function fieldDef(channel) {
      var channelDef = this.encoding[channel];
      return getTypedFieldDef(channelDef);
    }
  }, {
    key: "hasProjection",
    get: function get() {
      var encoding = this.encoding;
      var isGeoShapeMark = this.mark === GEOSHAPE;
      var hasGeoPosition = encoding && GEOPOSITION_CHANNELS.some(function (channel) {
        return isFieldDef(encoding[channel]);
      });
      return isGeoShapeMark || hasGeoPosition;
    }
  }, {
    key: "mark",
    get: function get() {
      return this.markDef.type;
    }
  }]);

  return UnitModel;
}(ModelWithField);